/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import { moveNavigationLeft, moveNavigationRight } from './arrowFunction';
import '../../../assets/scss/tabComponent.scss';
import { getBorderStyle, getTabstyle, getTabTitlestyle } from '../../../middleware/getStyle';
import { migrateSpecialCharacters } from '../../formComponent/utils';

const neutralizeAudioAutoplay = (html: string) => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = html;
  wrapper.querySelectorAll('audio[autoplay]').forEach((audio) => {
    audio.removeAttribute('autoplay');
    audio.setAttribute('data-autoplay', 'true');
  });
  return wrapper.innerHTML;
};

const StyledTabs = styled(Tabs) <{
  separatorBorder?: string;
  activeTabColor?: string;
  inactivefontColor?: string;
  activefontColor?: string;
}>`
  li button {
    border-width: 0px !important;
    border-right: ${(props) => props?.separatorBorder} !important;
    border-radius: 0px !important;
    padding-left: 5px !important;
    color: ${(props) => props.inactivefontColor} !important;
  }
  li button.active {
    background-color: ${(props) => props.activeTabColor} !important;
    color: ${(props) => props.activefontColor} !important;
  }
  li:last-child .nav-link {
    border-right: unset !important;
  }
`;
const TabComponent = (props: any) => {
  const { parameters, customisations } = props;
  const borderStyle = getBorderStyle(customisations);
  const tabStyle = getTabstyle(customisations);
  const tabTitleStyle = getTabTitlestyle(customisations);
  const borderRightStyle = `${customisations.separatorWidth ?? '0'}px solid ${
    customisations.separatorColor ?? '#000000'
  }`;
  const activeTabColor = customisations.displayActiveColorPicker ?? '#ffffff';
  const activefontColor = customisations.fontColor ?? '#000000';
  const inactivefontColor = customisations.inactivefontColor ?? '#000000';
  const handleLeftArrow = () => {
    moveNavigationLeft();
  };

  const handleRightArrow = () => {
    moveNavigationRight();
  };

  const playTabAudio = (index: number) => {
    document
      .getElementById(`tabpane-${index}`)
      ?.querySelectorAll<HTMLAudioElement>('audio[data-autoplay="true"]')
      .forEach((audio) => {
        audio.currentTime = 0;
        audio.play().catch(() => {});
      });
  };

  const pauseOtherTabsAudio = (activeIndex: number) => {
    parameters.forEach((_content: unknown, index: number) => {
      if (index === activeIndex) return;
      document
        .getElementById(`tabpane-${index}`)
        ?.querySelectorAll<HTMLAudioElement>('audio')
        .forEach((audio) => audio.pause());
    });
  };

  useEffect(() => {
    playTabAudio(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabSelect = (eventKey: string | null) => {
    if (eventKey === null) return;
    const index = Number(eventKey);
    pauseOtherTabsAudio(index);
    playTabAudio(index);
  };

  return (
    <div
      className={`border ${customisations.radius}`}
      role='button'
      tabIndex={0}
      aria-label='Tabs'
    >
      <div className='m-2 d-flex'>
        {parameters.length > 5 && (
          <button
            className='btn btn-link tab-control'
            tabIndex={0}
            aria-label='left'
            onClick={handleLeftArrow}
          >
            <i className='fa fa-caret-left arrow' />
          </button>
        )}
        <div
          className={`d-inline-block ${parameters.length > 5 ? 'custom-tab-container' : ' tab-container'
            }`}
        >
          <StyledTabs
            activeTabColor={activeTabColor}
            inactivefontColor={inactivefontColor}
            activefontColor={activefontColor}
            defaultActiveKey='0'
            className={`${customisations.fontHeadings} list-tab ${customisations.radius} li-tab ${parameters.length > 5 ? 'interactivetab' : ''
              }`}
            style={tabStyle}
            onSelect={handleTabSelect}
            onKeyDown={(e) => {
              if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && parameters.length > 5) {
                handleLeftArrow();
              } else if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const activeTab = document.querySelector('.tab-pane.active');
                const qlEditorDiv = activeTab?.querySelector('.m-3.ql-editor') as HTMLElement;
                qlEditorDiv.focus();
              }
            }}
            separatorBorder={borderRightStyle}
          >
            {parameters?.map((list: { title: string; text: string }, index: number) => (
              <Tab
                id={`tab-${index}`}
                eventKey={`${index}`}
                title={
                  <span title={list['title']} style={tabTitleStyle}>
                    {migrateSpecialCharacters(list['title'])}
                  </span>
                }
                key={`${index}`}
                className='tabcontent'
                style={borderStyle}
              >
                <div id={`tabpane-${index}`} className='m-3 ql-editor' role='button' tabIndex={0}>
                  {ReactHtmlParser(neutralizeAudioAutoplay(list['text']))}
                </div>
              </Tab>
            ))}
          </StyledTabs>
        </div>
        {parameters.length > 5 && (
          <button
            className='btn btn-link tab-control'
            tabIndex={0}
            aria-label='right'
            onClick={handleRightArrow}
          >
            <i className='fa fa-caret-right arrow' />
          </button>
        )}
      </div>
    </div>
  );
};

export default TabComponent;
